"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useMarkActivity;

var _useWebChatAPIContext = _interopRequireDefault(require("./useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useMarkActivity() {
  return (0, _useWebChatAPIContext.default)().markActivity;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VNYXJrQWN0aXZpdHkiLCJ1c2VXZWJDaGF0QVBJQ29udGV4dCIsIm1hcmtBY3Rpdml0eSJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2hvb2tzL2ludGVybmFsL3VzZU1hcmtBY3Rpdml0eS5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlV2ViQ2hhdEFQSUNvbnRleHQgZnJvbSAnLi91c2VXZWJDaGF0QVBJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZU1hcmtBY3Rpdml0eSgpIHtcbiAgcmV0dXJuIHVzZVdlYkNoYXRBUElDb250ZXh0KCkubWFya0FjdGl2aXR5O1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxlQUFULEdBQTJCO0VBQ3hDLE9BQU8sSUFBQUMsNkJBQUEsSUFBdUJDLFlBQTlCO0FBQ0QifQ==